import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  List,
  ListItem,
  ListItemIcon,
  Button,
} from "@mui/material";
import { useLoader } from "../../context/LoaderContext";
import { ReprocessSubSystem } from "../../api/downstreamSummaryApi/downstreamSummaryApi";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import { useSnackbar } from "../Common/SnackbarContext";

interface DownstreamSubSystemReprocessPopupProps {
  isOpen: boolean;
  onClose: (isCancelClick: boolean) => void;
  title: string;
  selectedData: any;
  documentStatusFlag: boolean;
}
const DownstreamSubSystemReprocessPopup: React.FC<
  DownstreamSubSystemReprocessPopupProps
> = ({ isOpen, onClose, title, selectedData, documentStatusFlag }) => {
  const { setLoading } = useLoader();
  const { showSnackbar } = useSnackbar();
  //Handel Yes
  const handleYes = async () => {
    try {
      setLoading(true);
      const response = await ReprocessSubSystem(selectedData);
      if (response.status === 200) {
        showSnackbar("Documents Reprocessed successfully");
        onClose(true);
      } else {
        showSnackbar(
          "Reprocess Failed - Please check the subsystem export is success or not.",
          true
        );
      }
    } catch (error) {
      console.log("Error in Reprocess Sub System. Please try again.");
    } finally {
      handleDialogClose(false);
      setLoading(false);
    }
  };

  //Handle dialog close
  const handleDialogClose = (confirm: boolean) => {
    onClose(false);
  };

  //Rendering Dialog Box for Downstream Sub System Reprocess Popup
  return (
    <Dialog open={isOpen} onClose={() => handleDialogClose(false)}>
      <DialogTitle
        style={{
          backgroundColor: "var(--primary-color)",
          color: "var(--aggrid-text-color)",
          fontSize: "16px",
          fontWeight: 500,
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
        }}
      >
        {title}
      </DialogTitle>
      <DialogContent
        style={{ fontSize: "12px", marginTop: "20px", padding: "1px 24px" }}
      >
        <DialogContentText>
          <List>
            {selectedData.map((data: any, i: number) => (
              <ListItem
                key={data.DocumentStreamId || data.FileName}
                sx={{ fontSize: "12px", margin: "2px 0", padding: "1px 1px" }}
              >
                <ListItemIcon sx={{ minWidth: "10px" }}>
                  <FiberManualRecordIcon sx={{ fontSize: "8px" }} />
                </ListItemIcon>
                {data.FileName}
              </ListItem>
            ))}
          </List>
          <div style={{ fontSize: "11px", margin: "1em" }}>
            Are you sure you want to proceed?
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          style={{
            textTransform: "none",
            borderRadius: "0px",
            backgroundColor: "var(--button-background-color)",
            color: "var(--button-color)",
            fontSize: "14px",
            height: "2.1em",
            padding: "4px 6px",
            border: "1px solid #144979",
          }}
          onClick={handleYes}
          color="primary"
        >
          Ok
        </Button>
        <Button
          style={{
            textTransform: "none",
            borderRadius: "0px",
            backgroundColor: "var(--button-background-color)",
            color: "var(--button-color)",
            fontSize: "14px",
            height: "2.1em",
            padding: "4px 6px",
            border: "1px solid #144979",
          }}
          onClick={() => onClose(false)}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};
export default DownstreamSubSystemReprocessPopup;
